module.exports = __webpack_public_path__ + "img/验证账户（验证账户是用户完成了身份认证以后才会出现）.fad811b2.png";